import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";

import {
  AppFailure,
  ErrorBoundary,
  ApplicationBase,
  ConfirmationDialog,
  NotificationContainer,
} from "altus-ui-components";

import theme from "layout/themes";
import { APP_NAME, IN_DEV } from "app/app.constants";
import { setApplicationFailure } from "app/app.actions";
import ApplicationContainer from "app/ApplicationContainer";
import ApplicationEnvironmentTopbar from "app/components/ApplicationEnvironmentTopbar";

const renderErrorContent = error => (
  <AppFailure errorMessage={IN_DEV ? error.message : undefined} />
);

const ApplicationRoot = ({ dispatchSetApplicationFailure }) => (
  <ApplicationBase appName={APP_NAME} theme={theme}>
    <ErrorBoundary
      onError={dispatchSetApplicationFailure}
      renderContent={renderErrorContent}
    >
      <ApplicationEnvironmentTopbar />
      <ApplicationContainer />
      <ConfirmationDialog />
      <NotificationContainer />
    </ErrorBoundary>
  </ApplicationBase>
);

export default compose(
  connect(null, {
    dispatchSetApplicationFailure: setApplicationFailure,
  }),
)(ApplicationRoot);
